import {configMt} from "../../constant/initDrawing";
import MainMTWrapper from "../../components/live2/mt/MainMTWrapper";

const config = {
    ...configMt,
    type: "vnone"
}

const Live2MCPage = () => {
    return <MainMTWrapper config={config}/>
}

export default Live2MCPage;